<script setup lang="ts"></script>

<template>
  <label class="tw-col-span-1 tw-text-gp-rhino md:tw-col-span-3 md:tw-text-end">
    <slot name="label"></slot>
  </label>

  <p
    class="tw-col-span-1 tw-text-end tw-text-xl tw-font-bold md:tw-col-span-1 md:tw-pr-4 lg:tw-pr-8"
  >
    <slot name="value"></slot>
  </p>
</template>

<style scoped></style>
